module.exports = __webpack_public_path__ + "img/borrower_benefit_uniqueplan.e623063b.jpg";